import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	customerDetails: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		data: {}
	},
	postBrowserDetails: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		result: {}
	},
	postCustomerDetails: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		result: {}
	}
};

export const customerDetailsSlice = createSlice({
	name: 'customerDetails',
	initialState,
	reducers: {
		getCustomerDetails: (state) => {
			state.customerDetails.isLoading = true;
		},
		getCustomerDetailsCompleted: (state, action) => {
			state.customerDetails.isLoading = false;
			state.customerDetails.hasCompleted = true;
			state.customerDetails.data = action.payload;
		},
		getCustomerDetailsFailed: (state, action) => {
			state.customerDetails.isLoading = false;
			state.customerDetails.error = action.payload;
		},
		getCustomerDetailsReset: (state) => {
			state.customerDetails = initialState.customerDetails;
		},
		postBrowserDetails: (state) => {
			state.postBrowserDetails.isLoading = true;
		},
		postBrowserDetailsCompleted: (state, action) => {
			state.postBrowserDetails.isLoading = false;
			state.postBrowserDetails.hasCompleted = true;
			state.postBrowserDetails.result = action.payload;
		},
		postBrowserDetailsFailed: (state, action) => {
			state.postBrowserDetails.isLoading = false;
			state.postBrowserDetails.error = action.payload;
		},
		postBrowserDetailsReset: (state) => {
			state.postBrowserDetails = initialState.postBrowserDetails;
		},
		postCustomerDetails: (state) => {
			state.postCustomerDetails.isLoading = true;
		},
		postCustomerDetailsCompleted: (state, action) => {
			state.postCustomerDetails.isLoading = false;
			state.postCustomerDetails.hasCompleted = true;
			state.postCustomerDetails.result = action.payload;
		},
		postCustomerDetailsFailed: (state, action) => {
			state.postCustomerDetails.isLoading = false;
			state.postCustomerDetails.error = action.payload;
		},
		postCustomerDetailsReset: (state) => {
			state.postCustomerDetails = initialState.postCustomerDetails;
		}
	}
});

export const {
	getCustomerDetails,
	getCustomerDetailsCompleted,
	getCustomerDetailsFailed,
	getCustomerDetailsReset,
	postBrowserDetails,
	postBrowserDetailsCompleted,
	postBrowserDetailsFailed,
	postCustomerDetails,
	postCustomerDetailsCompleted,
	postCustomerDetailsFailed,
	postCustomerDetailsReset
} = customerDetailsSlice.actions;

export default customerDetailsSlice.reducer;
